import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "s20 widget px-6 pt-8 pb-2" }
const _hoisted_2 = { class: "s20 gap-6 px-4 pb-6 collapse-content active" }
const _hoisted_3 = { class: "s20 flex gap-3 mb-2" }
const _hoisted_4 = { class: "form-field-split my-4" }
const _hoisted_5 = { class: "form-field-floating reactive search sm" }
const _hoisted_6 = { class: "form-field-split my-4" }
const _hoisted_7 = { class: "form-field-floating reactive sm" }
const _hoisted_8 = { class: "form-field-floating reactive sm" }
const _hoisted_9 = { class: "form-field-split my-4" }
const _hoisted_10 = { class: "form-field-floating reactive sm" }
const _hoisted_11 = { class: "form-field-floating reactive sm" }
const _hoisted_12 = { class: "s20 flex gap-3 mb-5" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "s20 flex gap-3 mb-5" }
const _hoisted_15 = { class: "s8" }
const _hoisted_16 = {
  key: 1,
  class: "text-center"
}
const _hoisted_17 = { class: "s10 px-4 mt-2" }
const _hoisted_18 = { class: "s10" }
const _hoisted_19 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_20 = { class: "s10" }
const _hoisted_21 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }

import { onMounted, ref, reactive, toRaw } from 'vue';
import { useToastStore } from '@/stores/toast.store';
import { formatAmount, formatDateFrench } from '@/utils';
import axios from 'axios';
import moment from 'moment';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserTransactions',
  props: {
    userId: {}
  },
  setup(__props: any) {

// @ts-expect-error raison: lib externe mal typée
const props = __props;

const queryParams = reactive({
    pageNumber: 1,
    borneInf: '',
    borneSup: '',
    search: '',
    banque_id: null as any,
});
const loadingListing = ref(false); const errorMessageListing = ref('');
const loadingChart = ref(false); const errorMessageChart = ref('');
const dateParams = reactive({
    dateInf: '',
    heureInf: '',
    dateSup: '',
    heureSup: '',
});
const pagination = reactive({
    total: 0,
    per_page: 10,
    last_page: 1
});
const itemsList = ref([] as any[]);
const banques = ref([] as any[]);
const seriesChart = [
    { name: "Décaissements", data: [] },
    { name: "Utilisation", data: [] }
];
const summaryDatas = ref({
    total_decaissements: 0,
    total_transactions: 0
});

const optionsChart = {
    colors: ["#359b74", "#a559ed"],
    chart: { toolbar: { show: false } },
    dataLabels: { enabled: false },
    stroke: { curve: "smooth" },
    fill: { opacity: 0.3 },
    xaxis: { categories: ["Jan", "Fev", "Mar", "Avr", "Mai", "Jun"] }
};

onMounted(() => {
    doListTransactions();
    doGetChartDatas();
});
async function doListTransactions() {
    try {
        loadingListing.value = true;
        errorMessageListing.value = '';
        const queryParamsRaw = toRaw(queryParams);
        const queryString = new URLSearchParams(Object.fromEntries(Object.entries(queryParamsRaw).map(([k,v]) => [k, String(v)]))).toString();
        const httpResponse = await axios.get(`/backoffice/users/${props.userId}/utilisation/list_transactions?${queryString}`);
        banques.value = httpResponse.data.banques;
        const transactions = httpResponse.data.transactions;
        itemsList.value = transactions.data;
        pagination.total = transactions.total;
        pagination.per_page = transactions.per_page;
        pagination.last_page = transactions.last_page;
    } catch (error: any) {
        errorMessageListing.value = error.message;
    } finally {
        loadingListing.value = false;
    }
}
async function doGetChartDatas() {
    try {
        loadingChart.value = true;
        errorMessageChart.value = '';
        const queryParamsRaw = toRaw(queryParams);
        const queryString = new URLSearchParams(Object.fromEntries(Object.entries(queryParamsRaw).map(([k,v]) => [k, String(v)]))).toString();
        const httpResponse = await axios.get(`/backoffice/users/${props.userId}/utilisation/get_transactions_chart_datas?${queryString}`);
        seriesChart[0].data = httpResponse.data.transactions_chart_datas.map((d: any) => d.total_decaissements);
        seriesChart[1].data = httpResponse.data.transactions_chart_datas.map((d: any) => d.total_transactions);
        Object.assign(summaryDatas, {
            total_decaissements: httpResponse.data.transaction_summary_datas.total_decaissements,
            total_transactions: httpResponse.data.transaction_summary_datas.total_transactions
        });
    } catch (error: any) {
        errorMessageChart.value = error.message;
    } finally {
        loadingChart.value = false;
    }
}

function onDateParamsChanged() {
    let borneInf: any = null;
    if (dateParams.dateInf) {
        borneInf = dateParams.dateInf;
        if (dateParams.heureInf) { borneInf += `T${dateParams.heureInf}`; }
        const borneInfMoment = moment(borneInf);
        if (borneInfMoment.isValid()) {
            queryParams.borneInf = borneInfMoment.format('YYYY-MM-DD HH:mm');
        }
    }

    let borneSup: any = null;
    if (dateParams.dateSup) {
        borneSup = dateParams.dateSup;
        if (dateParams.heureSup) { borneSup += `T${dateParams.heureSup}`; }
        const borneSupMoment = moment(borneSup);
        if (borneSupMoment.isValid()) {
            queryParams.borneSup = borneSupMoment.format('YYYY-MM-DD HH:mm');
        }
    }
    
    doListTransactions();
}

function onPaginate(pageNumber: number) {
    queryParams.pageNumber = pageNumber;
    doListTransactions();
}

function onSelectBanque(banque_id: number | null) {
    queryParams.banque_id = banque_id;
    doListTransactions();
}

return (_ctx: any,_cache: any) => {
  const _component_custom_pagination = _resolveComponent("custom-pagination")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[20] || (_cache[20] = _createStaticVNode("<div class=\"s10 mt--4 ml--4 mb-5 collapse-open active\"><span class=\"px-5 py-4 bg-color-black rounded-100 text-xl\"><img src=\"/icons/icon-panel-open.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-open\" alt=\"\"><img src=\"/icons/icon-panel-close.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-close\" alt=\"\"> Transactions </span></div><div class=\"s10 mt--5-5 flex-right\"><button class=\"btn lg py-3 black\"><img src=\"/icons/icon-pdf.svg\" class=\"btn-icon\" alt=\"\"><span>Exporter en PDF</span></button><button class=\"btn lg py-3 black\"><img src=\"/icons/icon-excel.svg\" class=\"btn-icon\" alt=\"\"><span>Exporter en Excel</span></button></div><div class=\"clear-both h-5\"></div>", 3)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-input",
              id: "filters_search",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryParams.search) = $event)),
              placeholder: "",
              onKeyup: _withKeys(doListTransactions, ["enter"])
            }, null, 544), [
              [_vModelText, queryParams.search]
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("label", { for: "date1" }, "Référence de transaction", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "date",
              class: "form-input",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dateParams.dateInf) = $event)),
              placeholder: "",
              onChange: onDateParamsChanged
            }, null, 544), [
              [_vModelText, dateParams.dateInf]
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("label", { for: "date1" }, "Date <=", -1))
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("hr", { class: "hr sm" }, null, -1)),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              type: "date",
              class: "form-input",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dateParams.dateSup) = $event)),
              placeholder: "",
              onChange: onDateParamsChanged
            }, null, 544), [
              [_vModelText, dateParams.dateSup]
            ]),
            _cache[9] || (_cache[9] = _createElementVNode("label", { for: "date2" }, "Date >=", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              type: "time",
              class: "form-input",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dateParams.heureInf) = $event)),
              placeholder: "",
              onChange: onDateParamsChanged
            }, null, 544), [
              [_vModelText, dateParams.heureInf]
            ]),
            _cache[11] || (_cache[11] = _createElementVNode("label", { for: "time1" }, "Heure <=", -1))
          ]),
          _cache[13] || (_cache[13] = _createElementVNode("hr", { class: "hr sm" }, null, -1)),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              type: "time",
              class: "form-input",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dateParams.heureSup) = $event)),
              placeholder: "",
              onChange: onDateParamsChanged
            }, null, 544), [
              [_vModelText, dateParams.heureSup]
            ]),
            _cache[12] || (_cache[12] = _createElementVNode("label", { for: "time1" }, "Heure >=", -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("span", {
          class: _normalizeClass(["btn", {'light': queryParams.banque_id == null, 'light2': queryParams.banque_id != null}]),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (onSelectBanque(null)))
        }, "Tout", 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(banques.value, (item, index) => {
          return (_openBlock(), _createElementBlock("span", {
            class: _normalizeClass(["btn", {'light': queryParams.banque_id == item.id, 'light2': queryParams.banque_id != item.id}]),
            key: index,
            onClick: ($event: any) => (onSelectBanque(item.id))
          }, _toDisplayString(item.nom), 11, _hoisted_13))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          (itemsList.value.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "flex gap-6 mb-4",
                    key: index
                  }, [...(_cache[14] || (_cache[14] = [
                    _createStaticVNode("<div class=\"square-xl px-4 py-4\" style=\"background-color:rgba(0, 185, 172, 0.08);\"><img src=\"/icons/icon-trans-recharger.svg\" width=\"100%\" class=\"icon-neutral\"></div><div class=\"s13 mt-2\"><h6 class=\"secondary-font font-semibold mb-1\">Rechargement de ma carte a partir de mon wallet</h6><p class=\"secondary-font text-sm text-grey-600 mb-2\">12 Mars 2024 à 14:32 - TCE441454</p></div><h5 class=\"s5 secondary-font text-right mt-2 text-green\">+ 50 000 F</h5>", 3)
                  ]))]))
                }), 128)),
                _createVNode(_component_custom_pagination, {
                  modelValue: queryParams.pageNumber,
                  "onUpdate:modelValue": [
                    _cache[6] || (_cache[6] = ($event: any) => ((queryParams.pageNumber) = $event)),
                    onPaginate
                  ],
                  total: pagination.total,
                  "per-page": pagination.per_page,
                  last_page: pagination.last_page
                }, null, 8, ["modelValue", "total", "per-page", "last_page"])
              ], 64))
            : _createCommentVNode("", true),
          (itemsList.value.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[15] || (_cache[15] = [
                _createElementVNode("h6", { class: "secondary-font font-semibold mb-1" }, "Aucune transaction enregistrée", -1)
              ]))]))
            : _createCommentVNode("", true)
        ]),
        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "s2 flex-center" }, [
          _createElementVNode("hr", { class: "hr-vertical h-500" })
        ], -1)),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _cache[16] || (_cache[16] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
              _createElementVNode("div", { class: "circle-medium bg-color-1000" }),
              _createTextVNode(" Décaissement ")
            ], -1)),
            _createElementVNode("h1", _hoisted_19, _toDisplayString(_unref(formatAmount)(summaryDatas.value.total_decaissements)) + " F", 1)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _cache[17] || (_cache[17] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
              _createElementVNode("div", { class: "circle-medium bg-purple" }),
              _createTextVNode(" Utilisation ")
            ], -1)),
            _createElementVNode("h1", _hoisted_21, _toDisplayString(_unref(formatAmount)(summaryDatas.value.total_transactions)) + " F", 1)
          ]),
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
          _createElementVNode("div", null, [
            _createVNode(_component_apexchart, {
              type: "area",
              height: "300",
              options: optionsChart,
              series: seriesChart
            })
          ])
        ])
      ])
    ])
  ]))
}
}

})